import React from 'react'
import { Toast } from '../../types/dataTypes'

type ToastProp = {
    setToastValue: React.Dispatch<React.SetStateAction<Toast>>
}
export const ToastContext = React.createContext<ToastProp>({
    setToastValue: {
        isToastShown: false,
        toastMessage: '',
        toastKey: '',
        toastSeverity: undefined,
        autoHideDuration: 2000,
    } as unknown as React.Dispatch<React.SetStateAction<Toast>>

}
)